import { handleRequestError } from 'src/services/api.js';
import { FeatureHintsService } from 'src/services/feature-hints.js';
import { getCookie, setInsecureCookie } from 'src/utils/cookies.js';

const ALREADY_READ_HINTS_COOKIE_NAME = 'read_feature_hints';
const ALREADY_READ_HINTS_BREAK = 24 * 60 * 60 * 365; // 1 год

function setAlreadyReadHints(slug) {
  let alreadyReadHints = getCookie(ALREADY_READ_HINTS_COOKIE_NAME);
  if (!alreadyReadHints) {
    alreadyReadHints = slug;
  } else {
    alreadyReadHints = `${alreadyReadHints},${slug}`;
  }
  setInsecureCookie(ALREADY_READ_HINTS_COOKIE_NAME, alreadyReadHints, {
    'max-age': ALREADY_READ_HINTS_BREAK,
  });
}

// eslint-disable-next-line complexity
export async function getHint(slug) {
  const alreadyReadHints = getCookie(ALREADY_READ_HINTS_COOKIE_NAME);
  if (alreadyReadHints && alreadyReadHints.split(',').includes(slug)) {
    return null;
  }
  const response = await FeatureHintsService.getFeatureHints(slug);
  if (!response.data.list || !response.data.list.length) return null;

  const hint = response.data.list.find((item) => item.slug === slug);

  if (!hint) return null;

  if (hint.hasBeenRead) {
    setAlreadyReadHints(hint.slug);
    return null;
  }

  return hint;
}

export async function markHintAsRead(slug) {
  try {
    setAlreadyReadHints(slug);
    await FeatureHintsService.markHintAsRead(slug);
  } catch (error) {
    handleRequestError(error);
  }
}
